import { api as generatedApi } from './operations.generated';

const tenantUserListTag = { type: 'TenantUser' as const, id: 'LIST' };

export const tenantUsersProvidesTags = (
  result: { Users?: { tenantUsers: Array<{ id: string }> } } | undefined,
) => {
  if (result?.Users?.tenantUsers) {
    return [
      ...result.Users.tenantUsers.map((item) => ({
        type: 'TenantUser' as const,
        id: item.id,
      })),
      tenantUserListTag,
    ];
  }
  return [tenantUserListTag];
};

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: ['TenantUser', 'TenantRoom'],
  endpoints: {
    UpdateUserProfile: {
      invalidatesTags: ['TenantRoom'],
    },
    GetTenantUsers: {
      providesTags: tenantUsersProvidesTags,
    },
    GetTenantUsersWithRoles: {
      providesTags: tenantUsersProvidesTags,
    },
  },
});
export const {
  useGetTenantUsersQuery,
  useLazyGetTenantUsersQuery,
  useGetTenantUsersWithRolesQuery,
  useLazyGetTenantUsersWithRolesQuery,
  useLazyAccountSetupStatusQuery,
} = api;
